<template>
  <span ref="selectorButton">
    <!-- @slot The button to trigger the uploader -->
    <slot />
  </span>
</template>
<script>
  import createUploader from "@/FormWidgets/UploaderWrapper/main";

  export default {
    name: "UploaderWrapper",
    // Vue 3:
    // emits: ['update:imageName', 'update:imagePath'],
    props: {
      /** The path to upload files to */
      tokenUrl: {
        type: String,
        required: true,
      }
    },
    data() {
      return {
        uppy: null,
      };
    },
    mounted() {
      this.uppy = createUploader(this.$refs.selectorButton, {
        tokenUrl: this.tokenUrl,
        onSuccessfulUpload: this.onSuccessfulUpload
      });
    },
    beforeDestroy() {
      this.uppy.close();
    },
    methods: {
      onSuccessfulUpload(name, path) {
        // Handle null or empty name:
        if(!name || name.trim().length === 0) {
          this.$emit('update:imageName', 'Attachment');
        } else {
          this.$emit('update:imageName', name);
        }
        this.$emit('update:imagePath', path);
        this.uppy.reset();
      }
    },
  };
</script>
